<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext.js';
    import { useFragment } from '$gql/fragment-masking.js';
    import {
        type BookmarkableInput,
        type BookmarkItemFragment,
        BookmarkItemFragmentDoc,
        CreateBookmarkItemMutationDocument,
        DeleteBookmarkItemMutationDocument,
    } from '$gql/graphql.js';
    import { cx } from '$lib/utils/cx.js';
    import EditBookmarkItemModal, { createModal } from './EditBookmarkItemModal.svelte';

    const apollo = getContainer().apollo();
    const {
        helpers: { addToast },
    } = getContainer().toaster();

    export let bookmarkItem: BookmarkItemFragment | null | undefined;
    export let className: string = '';
    export let checkedClassName: string = '';
    export let uncheckedClassName: string = '';
    export let target: BookmarkableInput;

    let loading: boolean = false;

    const modalEdit = createModal({ defaultOpen: false });

    const create = async () => {
        loading = true;
        const result = await apollo.mutate({
            mutation: CreateBookmarkItemMutationDocument,
            variables: {
                bookmarkName: 'default',
                target,
            },
            refetchQueries: ['active'],
            awaitRefetchQueries: true,
        });

        loading = false;
        let item = useFragment(BookmarkItemFragmentDoc, result.data?.bookmark.item);
        if (item != null) {
            addToast({
                data: {
                    type: 'success',
                    message: 'Ajouté aux favoris avec succès : dossier par défaut.',
                    actions: [
                        {
                            label: 'Modifier le dossier',
                            action() {
                                modalEdit.states.open.set(true);
                            },
                        },
                    ],
                },
            });
        }
    };

    const remove = async () => {
        loading = true;
        await apollo.mutate({
            mutation: DeleteBookmarkItemMutationDocument,
            variables: {
                id: bookmarkItem!.id,
            },
            refetchQueries: ['active'],
            awaitRefetchQueries: true,
        });

        loading = false;

        //const _m = result.data?.bookmark.target ?? null;
    };
</script>

<button
    disabled={loading}
    on:click|preventDefault={bookmarkItem == null ? create : remove}
    type={'button'}
    class={cx(
        'bg-transparent hover:bg-gray-200 cursor-pointer py-3 px-5 text-black rounded-full focus:outline-none inline-flex items-center',
        className,
        (bookmarkItem != null && !loading) || (bookmarkItem == null && loading)
            ? checkedClassName
            : '',
        (bookmarkItem == null && !loading) || (bookmarkItem != null && loading)
            ? uncheckedClassName
            : '',
    )}
>
    <slot />
</button>

{#if bookmarkItem}
    <EditBookmarkItemModal modal={modalEdit} {bookmarkItem} />
{/if}
